<template>

  <div id="app">

    <div v-if="isLoading" class="loading-container">
      <div class="loading">
        <Fade-loader />
      </div>
    </div>


    <div class="row">
      <div class="col-md-2 bg-light" style="position:fixed;height: 100%;">
        <div class="alert alert-secondary mt-3 ms-2 mb-1 pt-2 pb-2 text-start fs-3" role="alert">
          <b>지역선택</b>
        </div>
        <treeselect class="mt-0 ms-2" v-model="selectedCake" :multiple="true" :options="options" :flat="true"
          placeholder="지역선택하기" :always-open="true" :show-count="true" :value-consists-of="valueConsistsOf"
          :sort-value-by="sortValueBy" :limit="0" :limitText='count => `${count}개 시군구 선택됨`' clearAllText="모두 삭제"
          defaultExpandLevel="0" :max-height="600" />
      </div>


      <div class="col-md-10 offset-md-2">
        <div class="alert alert-secondary mt-3 mb-1 me-2 pt-2 pb-2 text-start fs-3" role="alert">
          <b>아파트매매가격지수</b>



          <div class="form-check form-switch float-end">
            <input class="form-check-input" @click="toggleCheckbox" type="checkbox" role="switch"
              id="flexSwitchCheckChecked" checked>
            <label class="form-check-label" for="flexSwitchCheckChecked">{{ pym2 }}</label>
          </div>
          <div class="form-check form-switch float-end">
            <input class="form-check-input" @click="toggleCheckbox1" type="checkbox" role="switch"
              id="flexSwitchCheckChecked1">
            <label class="form-check-label" for="flexSwitchCheckChecked1">{{ noise }}</label>
          </div>

        </div>

        <div class="text-start">
          <div class="btn-group btn-group-sm me-2" role="group" aria-label="Basic radio toggle button group">
            <input type="radio" class="btn-check" name="btnradio1" id="btnradio1" autocomplete="off" checked>
            <label class="btn btn-outline-primary" for="btnradio1">KB부동산</label>
          
            <!-- <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off">
                                          <label class="btn btn-outline-primary" for="btnradio2">Radio 2</label> -->
          
            <input type="radio" class="btn-check" name="btnradio1" id="btnradio2" autocomplete="off">
            <label class="btn btn-outline-primary" for="btnradio2">한국부동산원</label>
          </div>
          
          <div class="btn-group btn-group-sm me-2" role="group" aria-label="Basic radio toggle button group">
            <input type="radio" class="btn-check" name="btnradio3" id="btnradio3" autocomplete="off" checked>
            <label class="btn btn-outline-primary" for="btnradio3">월간</label>
          
            <!-- <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off">
                                                    <label class="btn btn-outline-primary" for="btnradio2">Radio 2</label> -->
          
            <input type="radio" class="btn-check" name="btnradio3" id="btnradio4" autocomplete="off">
            <label class="btn btn-outline-primary" for="btnradio4">주간</label>
          </div>
          
          <div class="btn-group btn-group-sm me-2" role="group" aria-label="Basic radio toggle button group">
            <input type="radio" class="btn-check" name="btnradio5" id="btnradio5" autocomplete="off" checked>
            <label class="btn btn-outline-primary" for="btnradio5">매매</label>
          
            <!-- <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off">
                                                              <label class="btn btn-outline-primary" for="btnradio2">Radio 2</label> -->
          
            <input type="radio" class="btn-check" name="btnradio5" id="btnradio6" autocomplete="off">
            <label class="btn btn-outline-primary" for="btnradio6">전세</label>
          </div>
          
          <div class="btn-group btn-group-sm me-2" role="group" aria-label="Basic radio toggle button group">
            <input type="radio" class="btn-check" name="btnradio_" id="btnradio_1" autocomplete="off" checked>
            <label class="btn btn-outline-primary" for="btnradio_1">1M</label>
          
            <!-- <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off">
                                                                        <label class="btn btn-outline-primary" for="btnradio2">Radio 2</label> -->
          
            <input type="radio" class="btn-check" name="btnradio_" id="btnradio_3" autocomplete="off" checked>
            <label class="btn btn-outline-primary" for="btnradio_3">3M</label>
          
            <input type="radio" class="btn-check" name="btnradio_" id="btnradio_6" autocomplete="off" checked>
            <label class="btn btn-outline-primary" for="btnradio_6">6M</label>
          
            <input type="radio" class="btn-check" name="btnradio_" id="btnradio_12" autocomplete="off" checked>
            <label class="btn btn-outline-primary" for="btnradio_12">1Y</label>
          </div>
        </div>


        <div class="me-2">



          <div>
            <div class="toolbar">
              <button id="one_month" @click="updateData('one_month')" :class="{ active: selection === 'one_month' }">
                1M
              </button>

              <button id="six_months" @click="updateData('six_months')" :class="{ active: selection === 'six_months' }">
                6M
              </button>

              <button id="one_year" @click="updateData('one_year')" :class="{ active: selection === 'one_year' }">
                1Y
              </button>

              <button id="ytd" @click="updateData('ytd')" :class="{ active: selection === 'ytd' }">
                YTD
              </button>

              <button id="all" @click="updateData('all')" :class="{ active: selection === 'all' }">
                ALL
              </button>
            </div>

            <div id="chart">
              <apexchart width="100%" height="500" :options="chartOptions" :series="series
              "></apexchart>
            </div>
            <div>
              <!-- <button @click="updateChart">Update!</button> -->
              <!-- <button @click="addSeries(48310)">Push series!</button> -->
              <!-- <button @click="modifySeries">Update first value all series!</button> -->
            </div>
          </div>
          <a href="http://localhost:8080/test.html" target="_blank">바로가기</a>
          <iframe src="http://localhost:8080/test.html" height="200" width="300" title="Iframe Example"></iframe>
          {{ selectedCake }}
          <!--한번호출해야차트그려짐-->
          {{ checked1 }}
          {{ chartOptions.xaxis }}


        </div>
      </div>
    </div>

    <!-- <div>Checked names: {{ checkedNames }}</div>
        <div v-for="(item, i) in R1Region" :value="item['id']" :key=i>
          <input type="checkbox" :id="i" :value="item.area_code5" v-model="checkedNames">
          <label :for="item.sigun">{{item.sigun}}</label>
        </div> -->


  </div>


</template>

<script>
import VueApexCharts from "vue3-apexcharts";
// import the component
import Treeselect from 'vue3-treeselect'
// import the styles
import 'vue3-treeselect/dist/vue3-treeselect.css'

import FadeLoader from 'vue-spinner/src/FadeLoader.vue'

export default {
  components: {
    FadeLoader,
    Treeselect,
    apexchart: VueApexCharts,
  },
  computed: {
    // user() {
    //   return this.$store.state.user;
    // },
    // checked() {
    //   let series1=[]
    //   let selectedCake=this.selectedCake
      
    //   // let categories1=[];
    //   for (let i = 0; i < selectedCake.length; i++) {
    //     let data=[]
    //     let sidosigun=[]        
    //     let R1WeekList1= [...this.R1WeekList].filter(item => item.sig_cd === selectedCake[i])
    //     let sido=R1WeekList1[0].sido
    //     let sigun=R1WeekList1[0].sigun
    //     sidosigun.push(sido+" "+sigun)          
    //     for (let i = 0; i < R1WeekList1.length; i++) {
    //       let ymd_1=new Date(R1WeekList1[i].ymd)
    //       let ymd=new Date(ymd_1.setDate(ymd_1.getDate() + 1))
    //       let value=R1WeekList1[i].value.toFixed(2)            
    //       // categories1.push(ymd)
    //       data.push([ymd,value])            
    //     }

    //     series1.push({name:sidosigun[0],data:data})                   
    //   }
    //   // this.chartOptions.xaxis.categories=categories1
    //   return series1
    // },
    checked1() {
      this.getR1WeekList1();
      return this.series1
    },    
   
  },  
  mounted() {
    // //computed에서user()로 pro사용자여부? computed의user()는 App.js의 async getUserAcount에서 선언함, 그리고 store,vuex로 상태관리함 + 아래 showAlert_NoUser()있어야함.
    // if (this.user != 1) {
    //     this.showAlert_NoUser();
    //     this.$router.push({ path: '/' });
    // }       
  },
  created() {
      // this.sido = this.$route.params.sido;
      // this.sigun = this.$route.params.sigun;
      

      this.getSidoList();
      this.getSigunList();
      this.getSigunList1();
      // this.getR1WeekList();
      this.getR1Region();
      this.getR1WeekList1();

  },  
  data() {
    return{
      isLoading: false,
      AptGradeList: [],
      SidoList: [],
      SigunList: [],
      SigunList1: [],
      DongList: [],
      Sigun1: [],
      Sigun2: [],
      Sigun3: [],
      sido: "경상남도",
      sigun: "진주시",
      sigun2: "진주시",
      dong: "",
      myNum:30,
      avgMax:"",
      selectedCake: [48170],         

      value: null,
      sort: {
          field: 'avg',
          desc: true        
      },    

      options: [{'id': 11000, 'label': '서울특별시', 'children': [{'id': 11110, 'label': '종로구'}, {'id': 11140, 'label': '중구'}, {'id': 11170, 'label': '용산구'}, {'id': 11200, 'label': '성동구'}, {'id': 11215, 'label': '광진구'}, {'id': 11230, 'label': '동대문구'}, {'id': 11260, 'label': '중랑구'}, {'id': 11290, 'label': '성북구'}, {'id': 11305, 'label': '강북구'}, {'id': 11320, 'label': '도봉구'}, {'id': 11350, 'label': '노원구'}, {'id': 11380, 'label': '은평구'}, {'id': 11410, 'label': '서대문구'}, {'id': 11440, 'label': '마포구'}, {'id': 11470, 'label': '양천구'}, {'id': 11500, 'label': '강서구'}, {'id': 11530, 'label': '구로구'}, {'id': 11545, 'label': '금천구'}, {'id': 11560, 'label': '영등포구'}, {'id': 11590, 'label': '동작구'}, {'id': 11620, 'label': '관악구'}, {'id': 11650, 'label': '서초구'}, {'id': 11680, 'label': '강남구'}, {'id': 11710, 'label': '송파구'}, {'id': 11740, 'label': '강동구'}]}, {'id': 41000, 'label': '경기도', 'children': [{'id': 41290, 'label': '과천시'}, {'id': 41171, 'label': '안양시 만안구'}, {'id': 41173, 'label': '안양시 동안구'}, {'id': 41131, 'label': '성남시 수정구'}, {'id': 41133, 'label': '성남시 중원구'}, {'id': 41135, 'label': '성남시 분당구'}, {'id': 41410, 'label': '군포시'}, {'id': 41430, 'label': '의왕시'}, {'id': 41550, 'label': '안성시'}, {'id': 41461, 'label': '용인시 처인구'}, {'id': 41463, 'label': '용인시 기흥구'}, {'id': 41465, 'label': '용인시 수지구'}, {'id': 41111, 'label': '수원시 장안구'}, {'id': 41113, 'label': '수원시 권선구'}, {'id': 41115, 'label': '수원시 팔달구'}, {'id': 41117, 'label': '수원시 영통구'}, {'id': 41190, 'label': '부천시'}, {'id': 41271, 'label': '안산시 상록구'}, {'id': 41273, 'label': '안산시 단원구'}, {'id': 41390, 'label': '시흥시'}, {'id': 41210, 'label': '광명시'}, {'id': 41590, 'label': '화성시'}, {'id': 41370, 'label': '오산시'}, {'id': 41220, 'label': '평택시'}, {'id': 41360, 'label': '남양주시'}, {'id': 41310, 'label': '구리시'}, {'id': 41450, 'label': '하남시'}, {'id': 41610, 'label': '광주시'}, {'id': 41500, 'label': '이천시'}, {'id': 41670, 'label': '여주시'}, {'id': 41570, 'label': '김포시'}, {'id': 41281, 'label': '고양시 덕양구'}, {'id': 41285, 'label': '고양시 일산동구'}, {'id': 41287, 'label': '고양시 일산서구'}, {'id': 41480, 'label': '파주시'}, {'id': 41650, 'label': '포천시'}, {'id': 41250, 'label': '동두천시'}, {'id': 41630, 'label': '양주시'}, {'id': 41150, 'label': '의정부시'}]}, {'id': 28000, 'label': '인천광역시', 'children': [{'id': 28110, 'label': '중구'}, {'id': 28140, 'label': '동구'}, {'id': 28177, 'label': '미추홀구'}, {'id': 28185, 'label': '연수구'}, {'id': 28200, 'label': '남동구'}, {'id': 28237, 'label': '부평구'}, {'id': 28245, 'label': '계양구'}, {'id': 28260, 'label': '서구'}]}, {'id': 26000, 'label': '부산광역시', 'children': [{'id': 26110, 'label': '중구'}, {'id': 26140, 'label': '서구'}, {'id': 26170, 'label': '동구'}, {'id': 26200, 'label': '영도구'}, {'id': 26230, 'label': '부산진구'}, {'id': 26290, 'label': '남구'}, {'id': 26470, 'label': '연제구'}, {'id': 26500, 'label': '수영구'}, {'id': 26350, 'label': '해운대구'}, {'id': 26410, 'label': '금정구'}, {'id': 26260, 'label': '동래구'}, {'id': 26710, 'label': '기장군'}, {'id': 26320, 'label': '북구'}, {'id': 26440, 'label': '강서구'}, {'id': 26530, 'label': '사상구'}, {'id': 26380, 'label': '사하구'}]}, {'id': 27000, 'label': '대구광역시', 'children': [{'id': 27110, 'label': '중구'}, {'id': 27140, 'label': '동구'}, {'id': 27170, 'label': '서구'}, {'id': 27200, 'label': '남구'}, {'id': 27230, 'label': '북구'}, {'id': 27260, 'label': '수성구'}, {'id': 27290, 'label': '달서구'}, {'id': 27710, 'label': '달성군'}]}, {'id': 29000, 'label': '광주광역시', 'children': [{'id': 29110, 'label': '동구'}, {'id': 29140, 'label': '서구'}, {'id': 29155, 'label': '남구'}, {'id': 29170, 'label': '북구'}, {'id': 29200, 'label': '광산구'}]}, {'id': 30000, 'label': '대전광역시', 'children': [{'id': 30110, 'label': '동구'}, {'id': 30140, 'label': '중구'}, {'id': 30170, 'label': '서구'}, {'id': 30200, 'label': '유성구'}, {'id': 30230, 'label': '대덕구'}]}, {'id': 31000, 'label': '울산광역시', 'children': [{'id': 31110, 'label': '중구'}, {'id': 31140, 'label': '남구'}, {'id': 31170, 'label': '동구'}, {'id': 31200, 'label': '북구'}, {'id': 31710, 'label': '울주군'}]}, {'id': 36110, 'label': '세종특별자치시', 'children': [{'id': 36110, 'label': '세종시'}]}, {'id': 42000, 'label': '강원도', 'children': [{'id': 42110, 'label': '춘천시'}, {'id': 42130, 'label': '원주시'}, {'id': 42150, 'label': '강릉시'}, {'id': 42170, 'label': '동해시'}, {'id': 42190, 'label': '태백시'}, {'id': 42210, 'label': '속초시'}, {'id': 42230, 'label': '삼척시'}]}, {'id': 43000, 'label': '충청북도', 'children': [{'id': 43111, 'label': '청주시 상당구'}, {'id': 43112, 'label': '청주시 서원구'}, {'id': 43113, 'label': '청주시 흥덕구'}, {'id': 43114, 'label': '청주시 청원구'}, {'id': 43130, 'label': '충주시'}, {'id': 43150, 'label': '제천시'}, {'id': 43770, 'label': '음성군'}]}, {'id': 44000, 'label': '충청남도', 'children': [{'id': 44131, 'label': '천안시 동남구'}, {'id': 44133, 'label': '천안시 서북구'}, {'id': 44150, 'label': '공주시'}, {'id': 44180, 'label': '보령시'}, {'id': 44200, 'label': '아산시'}, {'id': 44210, 'label': '서산시'}, {'id': 44230, 'label': '논산시'}, {'id': 44250, 'label': '계룡시'}, {'id': 44800, 'label': '홍성군'}, {'id': 44810, 'label': '예산군'}, {'id': 44270, 'label': '당진시'}]}, {'id': 45000, 'label': '전라북도', 'children': [{'id': 45111, 'label': '전주시 완산구'}, {'id': 45113, 'label': '전주시 덕진구'}, {'id': 45130, 'label': '군산시'}, {'id': 45140, 'label': '익산시'}, {'id': 45180, 'label': '정읍시'}, {'id': 45190, 'label': '남원시'}, {'id': 45210, 'label': '김제시'}]}, {'id': 46000, 'label': '전라남도', 'children': [{'id': 46110, 'label': '목포시'}, {'id': 46130, 'label': '여수시'}, {'id': 46150, 'label': '순천시'}, {'id': 46170, 'label': '나주시'}, {'id': 46230, 'label': '광양시'}, {'id': 46840, 'label': '무안군'}]}, {'id': 47000, 'label': '경상북도', 'children': [{'id': 47130, 'label': '경주시'}, {'id': 47190, 'label': '구미시'}, {'id': 47111, 'label': '포항시 남구'}, {'id': 47113, 'label': '포항시 북구'}, {'id': 47150, 'label': '김천시'}, {'id': 47170, 'label': '안동시'}, {'id': 47210, 'label': '영주시'}, {'id': 47230, 'label': '영천시'}, {'id': 47250, 'label': '상주시'}, {'id': 47280, 'label': '문경시'}, {'id': 47290, 'label': '경산시'}, {'id': 47850, 'label': '칠곡군'}]}, {'id': 48000, 'label': '경상남도', 'children': [{'id': 48121, 'label': '창원시 의창구'}, {'id': 48123, 'label': '창원시 성산구'}, {'id': 48125, 'label': '창원시 마산합포구'}, {'id': 48127, 'label': '창원시 마산회원구'}, {'id': 48129, 'label': '창원시 진해구'}, {'id': 48170, 'label': '진주시'}, {'id': 48220, 'label': '통영시'}, {'id': 48240, 'label': '사천시'}, {'id': 48250, 'label': '김해시'}, {'id': 48270, 'label': '밀양시'}, {'id': 48310, 'label': '거제시'}, {'id': 48330, 'label': '양산시'}]}, {'id': 50000, 'label': '제주특별자치도', 'children': [{'id': 50110, 'label': '제주시'}, {'id': 50130, 'label': '서귀포시'}]}],

      valueConsistsOf: 'LEAF_PRIORITY',
      sortValueBy: 'LEVEL',
      updateDate: "",
      blueList:['#f2f2ff', '#e6e6ff', '#d9d9ff', '#ccccff', '#bfbfff', '#b2b2ff', '#a6a6ff', '#9999ff', '#8c8cff', '#8080ff', '#7373ff', '#6666ff', '#5959ff', '#4d4dff', '#4040ff', '#3333ff', '#2626ff', '#1919ff', '#0d0dff', '#0000ff'],
      redList:['#fff2f2', '#ffe6e6', '#ffd9d9', '#ffcccc', '#ffbfbf', '#ffb2b2', '#ffa6a6', '#ff9999', '#ff8c8c', '#ff8080', '#ff7373', '#ff6666', '#ff5959', '#ff4d4d', '#ff4040', '#ff3333', '#ff2626', '#ff1919', '#ff0d0d', '#ff0000'],    
      
      //vue-good-table-next
      columns: [
        {
          label: '시도',
          field: 'sido2',
        },
        {
          label: '시군구',
          field: 'sigun2',
          // type: 'number',
        },
        {
          label: '읍면동 (급지분류 및 시세견인)',
          field: '법정동',
          // type: 'date',
          // dateInputFormat: 'yyyy-MM-dd',
          // dateOutputFormat: 'MMM do yy',
        },
        {
          label: '최소매매가',
          field: 'min',
          hidden: true,          
          type: 'number',
        },
        {
          label: '평균매매가',
          field: 'avg',
          type: 'number',
        }, 
        {
          label: '최대매매가',
          field: 'max',
          hidden: true,          
          type: 'number',
        },                   
        {
          label: '단지수',
          field: 'cnt',
          type: 'number',
        },
        {
          label: '5급지 분류',
          field: 'G5',
          // hidden: true,
          type: 'number',
        },
        {
          label: '시군구내순위',
          field: 'avg_rank',
          hidden: true,          
          type: 'number',
        },                        
      ],
      columns_mobie: [
        // {
        //   label: '시도',
        //   field: 'sido2',
        // },
        {
          label: '시군구',
          field: 'sigun2',
          // type: 'number',
        },
        {
          label: '동(대장,시세견인)',
          field: '법정동',
          // type: 'date',
          // dateInputFormat: 'yyyy-MM-dd',
          // dateOutputFormat: 'MMM do yy',
        },
        {
          label: 'min',
          field: 'min',
          hidden: true,          
          type: 'number',
        },
        {
          label: 'avg',
          field: 'avg',
          type: 'number',
        }, 
        {
          label: 'max',
          field: 'max',
          hidden: true,          
          type: 'number',
        },                   
        {
          label: '단지수',
          field: 'cnt',
          type: 'number',
        },
        // {
        //   label: '5급지',
        //   field: 'G5',
        //   // hidden: true,
        //   type: 'number',
        // },
        // {
        //   label: '시군구내순위',
        //   field: 'avg_rank',
        //   hidden: true,          
        //   type: 'number',
        // },                        
      ],      
      rows: [
        { id:1, name:"John", age: 20, createdAt: '',score: 0.03343 },
        { id:2, name:"Jane", age: 24, createdAt: '2011-10-31', score: 0.03343 },
        { id:3, name:"Susan", age: 16, createdAt: '2011-10-30', score: 0.03343 },
        { id:4, name:"Chris", age: 55, createdAt: '2011-10-11', score: 0.03343 },
        { id:5, name:"Dan", age: 40, createdAt: '2011-10-21', score: 0.03343 },
        { id:6, name:"John", age: 20, createdAt: '2011-10-31', score: 0.03343 },
      ],
      // vue-good-table-next      

      checkbox: false,
      checkbox1: false,

      pym2: '평당가',
      noise: '한국부동산원',

      styleClass: 'vgt-table bordered fs-6',

      series: [
        {
          name: "",
          data: []
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          dropShadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 0.2
          },
     toolbar: {
        show: true,
        offsetX: 0,
        offsetY: 0,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true | '<img src="/static/icons/reset.png" width="20">',
          customIcons: []
        },
        export: {
          csv: {
            filename: undefined,
            columnDelimiter: ',',
            headerCategory: 'category',
            headerValue: 'value',
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString()
            }
          },
          svg: {
            filename: undefined,
          },
          png: {
            filename: undefined,
          }
        },
        autoSelected: 'zoom' 
      },
        },
        colors: ['#77B6EA', '#545454','#000000', '#8A2BE2','#5F9EA0','#FF7F50','#DC143C','#008B8B','#8B008B','#9932CC','#8FBC8F','#2F4F4F'],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          // curve: 'smooth',
          width: 2,
        },
        title: {
          text: 'Average High & Low Temperature',
          align: 'left'
        },
        grid: {
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        // markers: {
        //   size: 1
        // },
        xaxis: {
          type: 'datetime',
          // categories: [],
          title: {
            text: 'datetime'
          }
        },
        yaxis: {
          title: {
            text: 'Temperature'
          }
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          floating: true,
          offsetY: -25,
          offsetX: -5
        }
      },
      checkedNames: [],
      R1Region:[],
      R1WeekList:[],
      R1WeekList1:[],      

    };
  },
  methods: {
    getavgMax() {
      let dataList = [];
      for (let i = 0; i < this.filters.length; i++) {
          dataList.push(Number(this.filters[i].avg))
      }
      this.avgMax = Math.max(...dataList)      
      // console.log(this.filters);
    },
    async getR1Region() {
        let R1Region = await this.$api("/api/R1Region","post")
        this.R1Region = R1Region;  
    },
    async getR1WeekList() {
      let R1WeekList = await this.$api("/api/R1WeekList","post",{ param: 48170 })
      this.R1WeekList=R1WeekList
    },
    async getR1WeekList1() {
      let selectedCake=this.selectedCake
      let R1WeekList1s=[]
      
      let series1=[]
      this.isLoading = true
      for (let i = 0; i < selectedCake.length; i++) {
        let R1WeekList1 = await  this.$axios(`/get/r1_month/매매/지수/${selectedCake[i]}`, {});
        let sido=R1WeekList1[0].sido
        let sigun=R1WeekList1[0].sigun
        let sidosigun=[]
        let data=[]

        // console.log(sido,sigun)
        sidosigun.push(sido+" "+sigun)
        for (let i = 0; i < R1WeekList1.length; i++) {
          let ymd_1=new Date(R1WeekList1[i].ymd)
          let ymd=new Date(ymd_1.setDate(ymd_1.getDate() + 1))
          let value=R1WeekList1[i].value.toFixed(2)            
          // categories1.push(ymd)
          data.push([ymd,value])                
        }
        series1.push({name:sidosigun[0],data:data})         
        R1WeekList1s.push(R1WeekList1)
      }
      
      this.series=series1
      this.isLoading = false
    },    
    // addSeries() {
    //   let selectedCake=this.selectedCake

    //   let series1=[]
    //   // for (let i = 0; i < selectedCake.length; i++) {
    //   let R1WeekList = this.$api("/api/R1WeekList",{ param: selectedCake[0] })
    //   //   let data1=[];
    //   //   let categories1=[];
    //   //   let sido=R1WeekList[0].sido
    //   //   let sigun=R1WeekList[0].sigun      
    //   //   for (let i = 0; i < R1WeekList.length; i++) {
    //   //     let ymd_1=new Date(R1WeekList[i].ymd)
    //   //     let ymd=new Date(ymd_1.setDate(ymd_1.getDate() + 1))
    //   //     let value=R1WeekList[i].value.toFixed(2)
    //   //     categories1.push(ymd)
    //   //     data1.push([ymd,value])
    //   //   }
        
    //   //   // console.log(data1)
    //   //   // console.log(categories1)

    //   //   // this.series[0].data = data1;
    //   //   // this.chartOptions.xaxis.categories = categories1;


    //   //   console.debug('Push new series');
    //   //   series1.push({
    //   //     name: sido+" "+sigun,
    //   //     data: data1,
    //   //   });
    //   // }
    //   console.log(R1WeekList)
    //   this.series=series1

    // },             
    async getSidoList() {
        let SidoList = await this.$api("/api/SidoList","post", {});
        this.SidoList = SidoList;
    },
    async getSigunList() {
        let SigunList = await this.$api("/api/SigunList","post", {});
        this.SigunList = SigunList;
    },
    async getSigunList1() {
        let SigunList1 = await this.$api("/api/SigunList1","post", { param: [this.sido] });
        this.SigunList1 = SigunList1;
    },
    changeSido() {
        // this.$router.push({ path: '/agt' });
        this.sido = '대구광역시';
        this.getUsers();
    },
    changeSigun() {
        // console.log(a)
        this.$router.push({ path: '/agt'});
    },

    sidoChange() {
      this.sigun='구미시';
    },

    changeMode() {
      this.modeBool = !this.modeBool;
      this.config.checkMode = this.modeBool ? 0 : 1;
    },

    getFormatDate(date) {
      const year = date.getFullYear();
      const month = (1 + date.getMonth());
      const day = date.getDate();
      return `${year}년 ${month}월 ${day}일 `; //Template literals 이용
    },
    doSort(field) {
        if(field == this.sort.field){
            this.sort.desc = !this.sort.desc
        }else{
            this.sort.field = field;
            this.sort.desc = true;
        }
    },
    heatMap(c_index_1,c_index) {
   
      if(c_index_1 > 0){
        if(c_index < 14) {
          return `position: absolute; top: 0px; left: 0px; right: 0px; z-index: 0; display: block; height: 100%; background-color: ${this.redList[c_index]}; color:black; text-align:left;`
        } else{
          return `position: absolute; top: 0px; left: 0px; right: 0px; z-index: 0; display: block; height: 100%; background-color: ${this.redList[c_index]}; color:white; text-align:left;`          
        }
      } else if(c_index_1 < 0) {
        if(c_index <= 8) {
          return `position: absolute; top: 0px; left: 0px; right: 0px; z-index: 0; display: block; height: 100%; background-color: ${this.blueList[c_index]}; color:black; text-align:left;`
        } else if(c_index > 8) {
          return `position: absolute; top: 0px; left: 0px; right: 0px; z-index: 0; display: block; height: 100%; background-color: ${this.blueList[c_index]}; color:white; text-align:left;`          
        }
      }
    },
    g5(c) {
      if(c === 1){
        return `badge bg-dark`
      } else if(c === 2) {
        return `badge bg-primary`
      } else if(c === 3) {
        return `badge bg-info text-dark`
      } else if(c === 4) {
        return `badge bg-secondary`
      } else if(c === 5) {
        return `badge bg-danger`
      }
    },
    toggleCheckbox() {
      this.checkbox = !this.checkbox
      if(this.checkbox==false) {
        this.pym2='평당가';
        // this.columns[6].hidden = false;
      } else {
        this.pym2='㎡당가';
        // this.columns[6].hidden = true;
      }
      // this.$emit('setCheckboxVal', this.checkbox)
    },
    toggleCheckbox1() {
      this.checkbox1 = !this.checkbox1
      if(this.checkbox1==false) {
        this.noise='한국부동산원';
        this.columns[3].hidden = true;
        this.columns[5].hidden = true;
        this.columns[8].hidden = true;
        this.styleClass ='vgt-table bordered fs-6';        
      } else {
        this.noise='KB부동산';
        this.columns[3].hidden = false;
        this.columns[5].hidden = false;
        this.columns[8].hidden = false;
        this.styleClass ='vgt-table bordered fs-6';        
      }

    },    

    updateData: function(timeline) {
      this.selection = timeline
  
      switch (timeline) {
        case 'one_month':
          this.$refs.chart.zoomX(
            new Date('28 Jan 2013').getTime(),
            new Date('27 Feb 2013').getTime()
          )
          break
        case 'six_months':
          this.$refs.chart.zoomX(
            new Date('27 Sep 2012').getTime(),
            new Date('27 Feb 2013').getTime()
          )
          break
        case 'one_year':
          this.$refs.chart.zoomX(
            new Date('27 Feb 2012').getTime(),
            new Date('27 Feb 2013').getTime()
          )
          break
        case 'ytd':
          this.$refs.chart.zoomX(
            new Date('01 Jan 2013').getTime(),
            new Date('27 Feb 2013').getTime()
          )
          break
        case 'all':
          this.$refs.chart.zoomX(
            new Date('23 Jan 2012').getTime(),
            new Date('27 Feb 2013').getTime()
          )
          break
        default:
      }
    },
    // showAlert() {
    //   this.$swal.fire({
    //       icon: 'warning',
    //       title: '로그인이 필요합니다.',
    //   });
    // },
    // showAlert_login() {
    //   this.$swal.fire({
    //     // position: 'bottom-end',
    //     icon: 'success',
    //     title: '로그인 되었습니다.',
    //     showConfirmButton: false,
    //     timer: 1500
    //   });    
    // },
    // showAlert_logout() {
    //   this.$swal.fire({
    //     // position: 'bottom-end',
    //     icon: 'success',
    //     title: '로그아웃 되었습니다.',
    //     showConfirmButton: false,
    //     timer: 1500
    //   });    
    // },    
    // showAlert_NoUser() {
    //   this.$swal.fire({
    //     // position: 'bottom-end',
    //     icon: 'success',
    //     title: '사용권한이 없습니다.',
    //     showConfirmButton: false,
    //     timer: 1500
    //   });    
    // },        

  
  },
  
};

</script>

<style scoped>
td {
  padding: 4px;
}

.loading {
  z-index: 2;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: rgba(0, 0, 0, 0.1) 0 0 0 9999px;
}
</style>